module.exports = __webpack_public_path__ + "img/mask-exchange.fe79caa8.png";